module.exports = __webpack_public_path__ + "img/packages/v3.3aa432.png";